<template>
  <div>
    <b-modal
        id="connect-marketplace-modal"
        :title="$t('pages.settings.connect_marketplace_modal.title')"
        centered
        size="lg"
        title-class="font-18"
        ok-variant="success"
        @hidden="handleClose"
    >
      <b-card-body>
        <b-row>
          <b-col cols="12" class="v-step2">
            <b-form-group
                class="mb-2"
                :label="$t('pages.settings.connect_marketplace_modal.marketplace_placeholder')"
                label-for="marketplace"
                label-cols="12"
                :description="$t('pages.settings.connect_marketplace_modal.marketplace_description')"
            >
              <market-place-select-component
                  v-model="marketplace"
                  id="marketplace"
                  :multiple="false"
                  :all="true"
                  :disabledRegions="disabledRegions"
                  :invalid="submitted && $v.marketplace.$error"
              />
              <div
                  v-if="submitted && !$v.marketplace.required"
                  class="d-block invalid-feedback"
              >
                {{ $t('pages.settings.connect_marketplace_modal.validations.marketplace_required') }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="v-step3">
            <b-form-group
                class="mb-3"
                :label="$t('pages.settings.connect_marketplace_modal.email')"
                label-for="email"
                label-cols="12"
                :description="$t('pages.settings.connect_marketplace_modal.description')"
            >
              <b-form-input
                  :placeholder="$t('pages.settings.connect_marketplace_modal.email_placeholder')"
                  v-model="email"
                  id="email"
                  type="email"
                  name="email"
                  :class="{'is-invalid': submitted && $v.email.$error   }"
              ></b-form-input>
              <div
                  v-if="submitted && !$v.email.required"
                  class="invalid-feedback"
              >
                {{ $t('pages.settings.connect_marketplace_modal.validations.email_required') }}
              </div>
              <div
                  v-if="submitted && !$v.email.email"
                  class="invalid-feedback"
              >
                {{ $t('pages.settings.connect_marketplace_modal.validations.email_invalid') }}
              </div>

            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="p-2 py-5 mb-3 bg-light" style="border-radius: 6px;">
              <ul class="verti-timeline list-unstyled">
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="me-3">
                      <i class="mdi mdi-account-arrow-right h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <div>
                        <p class="text-muted">
                          {{ $t('pages.settings.connect_marketplace_modal.infos.first') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="me-3">
                      <i class="mdi mdi-account-multiple-check h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <div>
                        <p class="text-muted">
                          {{ $t('pages.settings.connect_marketplace_modal.infos.second') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
      <template #modal-footer="{ cancel }">
        <b-button variant="danger" @click="cancel()">
          {{ $t('pages.settings.connect_marketplace_modal.cancel') }}
        </b-button>
        <a class="btn btn-primary v-step4" :class="{'disabled': !isDisableComputed}" @click="handleMwsConnection()">
          <b-spinner v-if="loading" small></b-spinner>
          {{ $t('pages.settings.connect_marketplace_modal.authorize') }}
        </a>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AuthService from "../../../Services/Api/AuthService";
import {email, required} from "vuelidate/lib/validators";
import MarketPlaceSelectComponent from "../../../components/widgets/MarketPlaceSelectComponent";

export default {
  name: "ConnectMarketPlaceModal",
  components: {MarketPlaceSelectComponent},
  props: ['region', 'disabledRegions'],
  data() {
    return {
      submitted: false,
      email: '',
      loading: false,
      marketplace: null,
      currentRegion: null
    }
  },
  validations: {
    email: {
      email,
      required
    },
    marketplace: {
      required
    }
  },
  computed: {
    isDisableComputed() {
      return !this.$v.email.$error || this.loading;
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
      this.canceled = true
      this.loading = false
    },
    async handleMwsConnection() {
      this.submitted = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        const newWindow = openWindow('', 'Amazon Connect', {
          mobile: this.$store.state.app.isMobile,
          alert: this.$t('pages.settings.connect_marketplace_modal.popup_error')
        })

        this.loading = true
        const payload = {
          seller_email: this.email,
          marketplace_id: this.marketplace.marketplace_id
        }
        const {data: url} = await AuthService.oauthLogin(payload)
        this.$emit('loginStarted', {url: url.data, region: this.marketplace.region, newWindow})
        this.$bvModal.hide('connect-marketplace-modal')
      }
    }
  }
}

/**
 * @param url
 * @param title
 * @param  {Object} options
 * @return {Window}
 */
function openWindow(url, title, options = {}) {
  if (typeof url === 'object') {
    options = url
    url = ''
  }
  options = {url, title, width: 700, height: 720, ...options}
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
  const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
  const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height
  options.self = "_self"
  options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
  options.top = ((height / 2) - (options.height / 2)) + dualScreenTop
  const optionsStr = Object.keys(options).reduce((acc, key) => {
    acc.push(`${key}=${options[key]}`)
    return acc
  }, []).join(',')

  let newWindow
  if (options.mobile) {
    newWindow = window.open(url, '_blank')
  } else {
    newWindow = window.open(url, title, optionsStr)
  }

  if (!newWindow) {
    alert(options.alert)
    return null
  } else if (window.focus) {
    newWindow.focus()
  }

  return newWindow
}
</script>

<style scoped>

</style>